import Request from '@/api/request';
const api = new Request('lk/');

export function getTextsByPage(pageTitle: string): Promise<Record<string, string>> {
    return api.post('getPageTitles', { pageTitle }).then((res: Record<string, string>) => res);
}
